import React, { createContext, useState, useContext } from 'react';
import moment from 'moment';
import { jwtDecode } from 'jwt-decode';
import { getOrdersAPI, updateOrderStatusAPI } from '../api-services/Orders.service';
import { API_NETWORK_ERROR, localStorageKeys } from '../../utils/constants';
import axios from 'axios';
import { GlobalStateDataContext } from './GlobalStateDataProvider';

// Work has to be done ,never tested this route ,just copied code ,need to test before merger this branch
export const OrderDataProviderContext = createContext();
const OrderDataProvider = ({ children }) => {
  const {
    isLoggedIn,
    selectedMenuTab,
    setSelectedMenuTab,
    setisLoggedIn,
    newPendingOrder,
    setNewPendingOrder,
    preparingOrder,
    setPreparingOrder,
    orderReadyForPickup,
    setOrderReadyForPickup,
    scheduledOrder,
    setScheduledOrder,
    openOrderAlert,
    setOpenOrderAlert,
    allOrders,
    setAllOrders,
    inHouseDeliveryOrders,
    setInHouseDeliveryOrders,
  } = useContext(GlobalStateDataContext);

  const [getOrderAPIResponse, setGetOrderAPIResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });

  const [updateOrderAPIResponse, setUpdateOrderAPIResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });
  const [clickedOrder, setClickedOrder] = useState({});
  const [clickedPreparingOrder, setClickedPreparingOrder] = useState({});

  const [clickedOrderReady, setClickedOrderReady] = useState({});
  const [clickedAllOrders, setClickedAllOrders] = useState({});
  const [selectedDate, setSelectedDate] = useState(moment());
  const currentDate = moment().format('MM/DD/YYYY');
  const { REFRESH_TOKEN, TOKEN } = localStorageKeys;
  const hasTokens = localStorage.getItem(TOKEN);

  let KitchenName = null;
  if (hasTokens) {
    const decodedToken = jwtDecode(hasTokens);
    const { email, kitchenName } = decodedToken || null;
    KitchenName = kitchenName;
  }

  const onGetOrders = async (payload) => {
    try {
      await setGetOrderAPIResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      if (hasTokens) {
        axios.defaults.headers.common.Authorization = `Bearer ${hasTokens}`;
      }

      const data = await getOrdersAPI(payload);

      if (data.hasError) {
        await setGetOrderAPIResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return data;
      }

      if (data?.data?.success) {
        await setGetOrderAPIResponse({
          loading: false,
          data: data?.data,
          success: data.data?.success,
          message: data.data?.message,
        });

        return data?.data;
      } else {
        await setGetOrderAPIResponse({
          loading: false,
          data: data?.data,
          success: data.data?.success,
          message: data.data?.message,
        });
      }
      return data?.data;
    } catch (error) {
      console.log('---Catch black onGetOrders', error);
      setGetOrderAPIResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  const onUpdateOrderStatus = async (payload) => {
    const { TOKEN } = localStorageKeys;
    const hasTokens = localStorage.getItem(TOKEN);

    try {
      await setUpdateOrderAPIResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      if (hasTokens) {
        axios.defaults.headers.common.Authorization = `Bearer ${hasTokens}`;
      }

      const data = await updateOrderStatusAPI(payload);

      if (data.hasError) {
        await setUpdateOrderAPIResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return data;
      }

      if (data?.data?.success) {
        await setUpdateOrderAPIResponse({
          loading: false,
          data: data?.data,
          success: data.data?.success,
          message: data.data?.message,
        });

        return data?.data;
      } else {
        await setUpdateOrderAPIResponse({
          loading: false,
          data: data?.data,
          success: data.data?.success,
          message: data.data?.message,
        });
      }
      return data?.data;
    } catch (error) {
      console.log('---Catch black onUpdateOrderStatus', error);
      setUpdateOrderAPIResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  // Below is old code have to delete after testing full
  // const checkOrderTime = (arg) => {
  //   console.log('----arg1', arg);
  //   const now = new Date();
  //   const [startTime] =
  //     (arg?.delivery_type === 'pickup' ? arg?.pickup_time_slot : arg?.delivery_time_slot)?.split(
  //       ' - '
  //     ) || [];
  //   const deliveryDateTimeStr = `${arg.delivery_date} ${startTime.trim()}`;
  //   const deliveryStartTime = new Date(deliveryDateTimeStr);
  //   const diffInMs = deliveryStartTime - now;
  //   const diffInHours = diffInMs / (1000 * 60 * 60);

  //   if (arg && arg?.delivered_by === 'kitchen' && arg?.delivery_type === 'home delivery') {
  //     setInHouseDeliveryOrders((prevOrders) => {
  //       const filteredOrders = prevOrders.filter((order) => order.order_no !== arg.order_no);

  //       return [arg, ...filteredOrders]; // push new order, remove old duplicate
  //     });

  //     setClickedOrder({});
  //   }

  //   if (arg && arg.internal_order_status === 'order canceled by customer') {
  //     const indexToRemove = newPendingOrder.findIndex((order) => order.order_no === arg.order_no);
  //     if (indexToRemove !== -1) {
  //       setNewPendingOrder((prevOrders) => {
  //         const filteredOrders = prevOrders.filter((order) => order.order_no !== arg.order_no);
  //         return [...filteredOrders]; // Add only if not a duplicate
  //       });

  //       setAllOrders((prevOrders) => {
  //         const filteredOrders = prevOrders.filter((order) => order.order_no !== arg.order_no);
  //         return [...filteredOrders, arg]; // Add only if not a duplicate
  //       });
  //     }
  //     setClickedOrder({});
  //   }

  //   if (arg && arg.internal_order_status === 'pending' && arg?.delivery_date === currentDate) {
  //     // Open new order alaram
  //     //  setOpenOrderAlert(true);

  //     if (diffInHours <= 3) {
  //       setNewPendingOrder((prevOrders) => {
  //         const existsInPending = prevOrders.some((order) => order.order_no === arg.order_no);

  //         const existsInScheduled = scheduledOrder?.some(
  //           (order) => order.order_no === arg.order_no
  //         );

  //         const existsInPreparing = preparingOrder?.some(
  //           (order) => order.order_no === arg.order_no
  //         );

  //         const existsInReady = orderReadyForPickup?.some(
  //           (order) => order.order_no === arg.order_no
  //         );

  //         const existsInAllOrders = allOrders?.some((order) => order.order_no === arg.order_no);

  //         const alreadyExists =
  //           existsInPending ||
  //           existsInScheduled ||
  //           existsInPreparing ||
  //           existsInReady ||
  //           existsInAllOrders;

  //         if (alreadyExists) {
  //           return prevOrders;
  //         }

  //         return [...prevOrders, arg];
  //       });
  //     } else if (diffInHours > 3) {
  //       setScheduledOrder((prevOrders) => {
  //         const filteredOrders = prevOrders.filter((order) => order.order_no !== arg.order_no);
  //         return [...filteredOrders, arg]; // Add only if not a duplicate
  //       });
  //     }
  //   } else if (
  //     arg &&
  //     arg.internal_order_status === 'pending' &&
  //     arg?.delivery_date !== currentDate
  //   ) {
  //     setScheduledOrder((prevOrders) => {
  //       const filteredOrders = prevOrders.filter((order) => order.order_no !== arg.order_no);
  //       return [...filteredOrders, arg]; // Add only if not a duplicate
  //     });
  //   } else if (arg && arg.internal_order_status === 'order accepted by kitchen') {
  //     setPreparingOrder((prevOrders) => {
  //       const isDuplicate = prevOrders.some((order) => order.order_no === arg.order_no);
  //       if (isDuplicate) return prevOrders; // Don't add duplicate
  //       return [...prevOrders, arg]; // Add only if not a duplicate
  //     });
  //   } else if (
  //     arg &&
  //     (arg.internal_order_status === 'order ready for pickup' ||
  //       arg.internal_order_status === 'driver pickup pending')
  //   ) {
  //     setOrderReadyForPickup((prevOrders) => {
  //       const filteredOrders = prevOrders.filter((order) => order.order_no !== arg.order_no);
  //       return [...filteredOrders, arg]; // Add only if not a duplicate
  //     });

  //     setClickedOrderReady({});
  //   } else if (arg && arg.internal_order_status === 'driver picked the order') {
  //     setClickedOrderReady({});
  //     setOrderReadyForPickup((prevOrders) => {
  //       const filteredOrders = prevOrders.filter((order) => order.order_no !== arg.order_no);
  //       return [...filteredOrders];
  //     });

  //     setAllOrders((prevOrders) => {
  //       const filteredOrders = prevOrders.filter((order) => order.order_no !== arg.order_no);
  //       return [...filteredOrders, arg];
  //     });
  //   } else {
  //     setAllOrders((prevOrders) => {
  //       const filteredOrders = prevOrders.filter((order) => order.order_no !== arg.order_no);
  //       return [...filteredOrders, arg]; // Add only if not a duplicate
  //     });
  //   }
  // };

  const checkOrderTime = (arg) => {
    if (!arg?.order_no || !arg?.internal_order_status) return;

    const orderNo = arg.order_no;
    const status = arg.internal_order_status;

    // Pickup and home delivery have different date/time fields.
    const orderDate = arg.delivery_type === 'pickup' ? arg.order_date : arg.delivery_date;

    const orderTimeSlot =
      arg.delivery_type === 'pickup' ? arg.pickup_time_slot : arg.delivery_time_slot;

    // Calculate hours remaining until the order time.
    let diffInHours = null;

    if (orderDate && orderTimeSlot) {
      const startTime = orderTimeSlot.split(' - ')[0]?.trim();

      if (startTime) {
        const orderStartTime = new Date(`${orderDate} ${startTime}`);

        if (!Number.isNaN(orderStartTime.getTime())) {
          diffInHours = (orderStartTime.getTime() - Date.now()) / (1000 * 60 * 60);
        }
      }
    }

    // Remove order from a state.
    const removeOrder = (setState) => {
      setState((prev) => prev.filter((order) => order.order_no !== orderNo));
    };

    // Add or update order in a state.
    const addOrder = (setState) => {
      setState((prev) => [...prev.filter((order) => order.order_no !== orderNo), arg]);
    };

    // Remove the order from all primary states.
    removeOrder(setNewPendingOrder);
    removeOrder(setScheduledOrder);
    removeOrder(setPreparingOrder);
    removeOrder(setOrderReadyForPickup);
    removeOrder(setAllOrders);

    // Keep in-house delivery orders updated separately.
    if (arg.delivery_type === 'home delivery' && arg.delivered_by === 'kitchen') {
      addOrder(setInHouseDeliveryOrders);
    } else {
      removeOrder(setInHouseDeliveryOrders);
    }

    // 1. New pending order
    if (status === 'pending') {
      if (diffInHours !== null && diffInHours > 3) {
        addOrder(setScheduledOrder);
      } else {
        addOrder(setNewPendingOrder);
      }

      return;
    }

    // 2. Kitchen accepted the order
    if (status === 'order accepted by kitchen') {
      addOrder(setPreparingOrder);
      setClickedOrder({});
      return;
    }

    // 3. Order ready for pickup or driver assignment
    if (status === 'order ready for pickup' || status === 'driver pickup pending') {
      addOrder(setOrderReadyForPickup);
      setClickedOrderReady({});
      return;
    }

    // 4. All remaining statuses
    // Includes delivered, canceled, driver picked up,
    // customer picked up, and other statuses.
    addOrder(setAllOrders);

    setClickedOrder({});
    setClickedOrderReady({});
  };

  const FetchOrders = async (payloadOrderfetch) => {
    setNewPendingOrder([]);
    setPreparingOrder([]);
    setOrderReadyForPickup([]);
    setScheduledOrder([]);
    setInHouseDeliveryOrders([]);
    setAllOrders([]);

    const payload = {
      ...payloadOrderfetch,
      kitchen_name: KitchenName,
      order_history: false,
    };

    const OrderData = await onGetOrders(payload);

    // if (OrderData?.joinedOrders?.length > 0) {
    //   OrderData?.joinedOrders?.forEach((order) => {
    //     const OrderInformation = {
    //       ...order.payAsYouGoOrder,
    //       order_no: order.payAsYouGoOrder?.joined_order_no
    //         ? order.payAsYouGoOrder?.joined_order_no
    //         : order.payAsYouGoOrder?.order_no,
    //       item_names: [
    //         ...(order.payAsYouGoOrder?.item_names || []),
    //         ...(order.mealOrder?.item_name || []),
    //       ],
    //     };
    //     checkOrderTime(OrderInformation);
    //   });
    // }

    // if (OrderData?.mealOrders?.length > 0) {
    //   OrderData?.mealOrders?.forEach((order) => {
    //     checkOrderTime(order);
    //   });
    // }

    if (OrderData?.payAsYouGoOrders?.length > 0) {
      OrderData?.payAsYouGoOrders?.forEach((order) => {
        checkOrderTime(order);
      });
    }

    if (OrderData?.PromotionalOrders?.length > 0) {
      OrderData?.PromotionalOrders?.forEach((order) => {
        checkOrderTime(order);
      });
    }

    return OrderData;
  };

  return (
    <OrderDataProviderContext.Provider
      value={{
        getOrderAPIResponse,
        setGetOrderAPIResponse,
        onGetOrders,
        onUpdateOrderStatus,
        updateOrderAPIResponse,
        setUpdateOrderAPIResponse,
        FetchOrders,
        checkOrderTime,
        KitchenName,
        clickedOrder,
        setClickedOrder,
        clickedPreparingOrder,
        setClickedPreparingOrder,
        clickedOrderReady,
        setClickedOrderReady,
        clickedAllOrders,
        setClickedAllOrders,
        selectedDate,
        setSelectedDate,
        currentDate,
      }}
    >
      {children}
    </OrderDataProviderContext.Provider>
  );
};

export default OrderDataProvider;
